export const BRAND = {
  name: "ImmoBF",
  shortName: "ImmoBF",
  initials: "IB",
  tagline: "Gestion immobilière simplifiée au Burkina Faso",
  description:
    "La plateforme qui centralise vos immeubles, biens, locataires, contrats, loyers, paiements, impayés, entretiens et documents.",
  email: "support@burkina-immo.com",
  noReply: "no-reply@burkina-immo.com",
  phone: "+226 64 59 17 18",
  whatsapp: "+226 64 59 17 18",
  address: "Avenue Kwame N'Krumah, Ouagadougou, Burkina Faso",
  domain: "https://burkina-immo.com",
  country: "Burkina Faso",
  currency: "FCFA",
  year: 2026,
};

export type BrandType = typeof BRAND;